import { FaArrowLeft } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { useAuth } from "../../context/AuthProvider";

interface HeroSectionProps {
  onOpen: () => void;
}

const HeroSection = ({ onOpen }: HeroSectionProps) => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <div className="h-[665px] md:h-[646px] bg-[url('/images/hero_bg2.png')] bg-cover bg-center relative">
        <header className="container mx-auto h-[154px] md:h-[232px] p-10 md:p-4">
          <nav>
            <div className="flex items-center justify-between">
              <FiMenu className="w-[38px] h-[38px] text-white" />

              <div className="absolute left-1/2 mt-3.5 md:mt-0 -translate-x-1/2 md:static md:translate-x-0 visible md:invisible">
                <img
                  src="/images/vac_logo.png"
                  alt="VAC Logo"
                  width={232}
                  height={232}
                  className="size-[154px] md:size-[232px]"
                />
              </div>

              <div className="hidden md:block relative w-[153px] border-l-2 border-[#D9D9D9]">
                <div className="ml-2 text-white text-left flex flex-col justify-center">
                  <span className="text-lg font-kalameh font-light">واک</span>
                  <span className="text-lg font-kalameh font-light">
                    دانشگاه و
                  </span>
                  <span className="text-lg font-kalameh font-light">
                    باشگاه صدا
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center">
              <div className="bg-white/25 w-full md:w-8/12 lg:w-[896px] h-52 md:h-80 lg:h-[505px] mx-auto rounded-4xl p-2 mt-24 md:mt-32 lg:mt-0 z-10">
                <div className="w-full h-full bg-[#242424] rounded-4xl overflow-hidden flex items-center justify-center">
                  <video
                    className="w-full h-full object-cover rounded-4xl"
                    src="https://vod.vac.academy/vac-academy.mp4"
                    controls
                    autoPlay={false}
                    loop={false}
                    muted={false}
                  />
                </div>
              </div>

              <div className="w-36 h-36 blur-3xl bg-[#54C6F9]/90 rounded-full -mt-24"></div>

              <h1 className="font-kalameh text-[64px] text-[#54C6F9] -mt-10 md:mt-0 text-center">
                سلام رفیق
              </h1>

              <p className="font-kalameh font-normal text-2xl visible md:invisible leading-[32px] text-white text-center mt-2">
                به مینی دوره ۳ روزه صداسازی خوش اومدی و دمت گرم که برای رشد صدات
                قدم برمیداری!
              </p>
            </div>
          </nav>
        </header>

        {!isAuthenticated && (
          <div className="absolute bottom-3 left-3 invisible xl:visible">
            <button
              onClick={onOpen}
              className="bg-[#0F0F0F] px-2.5 h-[51px] text-white text-sm font-kalameh rounded-[13px] flex items-center justify-center gap-2.5 hover:cursor-pointer"
            >
              ثبت نام رایگان و شروع
              <FaArrowLeft className="text-white w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default HeroSection;
